import { createTheme } from '@mui/material/styles';
import { KeyboardArrowDown } from '@mui/icons-material';
import { getFontSize } from './constants/fontSizes';

const theme = createTheme({
  palette: {
    primary: {
      main: '#00443F',
      dark: "#00443F",
  
    },
    secondary: {
      main: '#fff',
      dark: '#fff',
    },
    text: {
      primary: '#ffff',
      secondary: '#252629CC',
    },
    mode: 'dark', // Since primary text is white, using dark mode
  },
  typography: {
    fontFamily: [
      'Lato',
      'Aurora',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  // Extend the theme to include custom colors
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#252629',
          fontFamily: "'Lato', sans-serif",
        },
        '*': {
          boxSizing: 'border-box',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            opacity: 0.9,
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: '#fff',
          borderRadius: '14px',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: '#1F1F1F',
          fontFamily: 'Lato',
          fontSize: getFontSize(18),
          padding: '12px 24px',
          '&:hover': {
            backgroundColor: 'rgba(0, 68, 63, 0.1)',
          },
          '&.Mui-selected': {
            backgroundColor: 'rgba(0, 68, 63, 0.15)',
            color: '#00443F',
            '&:hover': {
              backgroundColor: 'rgba(0, 68, 63, 0.2)',
            },
          },
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        IconComponent: KeyboardArrowDown,
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          backgroundColor: '#fff',
          color: '#1F1F1F',
        },
      },
    },
  },
});

// Add custom accent color to the theme palette
// You can access it via theme.palette.accent.main in your components
theme.palette.accent = {
  main: '#BCA08A',
};

export default theme;

